webpackJsonp([149121111297344],{

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(45);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(179);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactIntl = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services(_ref) {
	  var images = _ref.images,
	      intl = _ref.intl;
	
	  var websiteItems = __webpack_require__(508)("./" + intl.locale).services.websites.list; // eslint-disable-line
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        intl.formatMessage({ id: 'services.title' })
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: intl.formatMessage({ id: 'services.desc' }) })
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'banner', className: 'style2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'header',
	          { className: 'major' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.header', tagName: 'h1' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.desc', tagName: 'p' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'main' },
	      _react2.default.createElement(
	        'section',
	        { id: 'one' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.main.header', tagName: 'h2' })
	          ),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.main.desc', tagName: 'p' }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'actions' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '#two', className: 'button scrolly' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.main.cta' })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'two', className: 'spotlights services-two' },
	        _react2.default.createElement(
	          'section',
	          { id: 'websites' },
	          _react2.default.createElement('div', { className: 'image', style: { backgroundImage: 'url(' + images.websites + ')' } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inner' },
	              _react2.default.createElement(
	                'header',
	                { className: 'major' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.websites.header', tagName: 'h3' })
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'services-websites--list' },
	                Object.keys(websiteItems).map(function (item) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: item },
	                    websiteItems[item]
	                  );
	                })
	              ),
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'services.websites.more.content',
	                tagName: 'p',
	                values: {
	                  anchor: _react2.default.createElement(
	                    _reactIntl.FormattedMessage,
	                    { id: 'services.websites.more.anchor' },
	                    function (text) {
	                      return _react2.default.createElement(
	                        'a',
	                        { href: (0, _gatsbyLink.withPrefix)('/' + intl.locale + '/#contact') },
	                        text
	                      );
	                    }
	                  )
	                }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { id: 'apps' },
	          _react2.default.createElement('div', { className: 'image', style: { backgroundImage: 'url(' + images.mobileapps + ')' } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inner' },
	              _react2.default.createElement(
	                'header',
	                { className: 'major' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.apps.header', tagName: 'h3' })
	              ),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.apps.desc.p1', tagName: 'p' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.apps.desc.p2', tagName: 'p' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.apps.desc.p3', tagName: 'p' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { id: 'consulting' },
	          _react2.default.createElement('div', { className: 'image', style: { backgroundImage: 'url(' + images.consulting + ')' } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'inner' },
	              _react2.default.createElement(
	                'header',
	                { className: 'major' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.header', tagName: 'h3' })
	              ),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.desc', tagName: 'p' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.software.header', tagName: 'h4' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.software.desc', tagName: 'p' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.solutions.header', tagName: 'h4' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.solutions.desc', tagName: 'p' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.pm.header', tagName: 'h4' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.pm.desc', tagName: 'p' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.strategy.header', tagName: 'h4' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'services.consulting.strategy.desc', tagName: 'p' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	Services.propTypes = {
	  images: _propTypes2.default.shape({
	    consulting: _propTypes2.default.string.isRequired,
	    mobileapps: _propTypes2.default.string.isRequired,
	    websites: _propTypes2.default.string.isRequired
	  }).isRequired,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(Services);
	module.exports = exports['default'];

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  about: {
	    title: 'About Webjomp',
	    desc: {
	      1: 'Founder of Webjomp, François-Xavier Lemire a B.Sc. in Computer Science with a major in software engineering from ' + 'McGill University in 2016. He also holds an LL.B. from the Université de Montréal since 2010 and is registered to the ' + 'Québec Bar Roll of Order since 2011, being a former lawyer at {lla}',
	      2: 'François-Xavier has applied his unique engineering skills in many domains including {fintech} at {morgan}, mobile ' + 'in-app advertising at {vungle}, San Francisco and gaming at {beenox} where he worked on the blockbuster success {skylanders}.',
	      3: 'If you don’t find him brainstorming for the next big thing, he’s most probably playing trumpet, tasting scotch or boxing!',
	      4: 'Make sure to stay in touch!'
	    }
	  },
	  banner: {
	    header: {
	      default: 'The web, ',
	      span: 'reimagined'
	    },
	    desc: 'Website design, mobile app development and consulting.',
	    cta: 'Learn More'
	  },
	  contact: {
	    title: 'Contact Us',
	    form: {
	      name: 'Name',
	      email: 'E-mail',
	      topic: 'Topic',
	      message: 'Message',
	      receiveCopy: 'Receive a copy',
	      send: 'Send',
	      confirm: {
	        success: 'ReCaptcha solved? We\'ll get back to you very soon!',
	        error: 'ERROR: There was an error sending the form. Please try again later.',
	        popup: 'ERROR: Please allow popups, then retry and complete a reCaptcha.',
	        close: 'Close'
	      }
	    },
	    email: 'E-mail',
	    phone: 'Phone',
	    where: 'Where'
	  },
	  menu: {
	    home: 'Home',
	    contact: 'Contact',
	    about: {
	      title: 'About Us',
	      page: 'about'
	    },
	    services: {
	      title: 'Our Services',
	      page: 'services'
	    }
	  },
	  landing: {
	    tiles: {
	      moderne: {
	        title: 'Modern websites',
	        desc: 'Attract your clients with a fresh look.'
	      },
	      agile: {
	        title: 'Agile',
	        desc: 'Be involved throughout your website\'s creation and get the result you want.'
	      },
	      beton: {
	        title: 'Rock Solid',
	        desc: 'We use cutting-edge technologies to ensure your website stays fast, bug-free and up to date.'
	      },
	      adaptatif: {
	        title: 'Responsive',
	        desc: 'Enjoy good UI and UX, whether on mobile or PC.'
	      },
	      clair: {
	        title: 'Which You\'ll Understand',
	        desc: 'We make sure all your questions are answered.'
	      },
	      abordable: {
	        title: 'At reasonable prices',
	        desc: 'We minimize accessory fees such as hosting and domain acquisition.'
	      }
	    },
	    services: {
	      title: 'Our Services',
	      websites: 'Websites',
	      apps: 'Apps',
	      consulting: 'Consulting',
	      cta: 'Learn More'
	    },
	    clients: { title: 'Some of our clients' }
	  },
	  services: {
	    title: 'Webjomp - Services',
	    header: 'Our Services',
	    desc: 'Website design, mobile app development and consulting.',
	    main: {
	      header: 'Way more than websites',
	      desc: 'On top of website design, Webjomp offers a wide variety of services such as custom mobile app (Android, iOS and Windows) ' + 'and software development tailored to the needs of your industry.',
	      cta: 'Learn more'
	    },
	    websites: {
	      header: 'Websites',
	      list: {
	        1: 'eCommerce',
	        2: 'Responsive',
	        3: 'Blogs',
	        4: 'Search Engine Optimization (SEO)',
	        5: 'Email Marketing',
	        6: 'Writing and Translation',
	        7: 'Original Designs and Makeovers',
	        8: 'Static and Dynamic Pages',
	        9: 'Maps and Calendars',
	        10: 'Social Networks',
	        11: 'Chat Platform',
	        12: 'Contact Forms',
	        13: 'Data Analytics',
	        14: 'Advertisement',
	        15: 'Custom Domain Acquisition',
	        16: 'Web Hosting'
	      },
	      more: {
	        content: 'Can\'t find what you need? Don\'t hesitate to {anchor}!',
	        anchor: 'contact us'
	      }
	    },
	    apps: {
	      header: 'Mobile Apps',
	      desc: {
	        p1: 'We develop for Android, iOS and Windows Phones.',
	        p2: 'You have an idea in mind? We bring it to life with you through the following steps: ' + 'identify the requirements, create a design, develop and test the features, publish the app to the store.',
	        p3: 'But that\'s not all! We stay with you and keep your app up to date to ensure its performance, and we ' + 'improve its design and features by analyzing your users\' data and behavior.'
	      }
	    },
	    consulting: {
	      header: 'Consulting',
	      desc: 'Focus on what you\'re pro at.',
	      software: {
	        header: 'Custom Software Development',
	        desc: 'Data visualization, task automation.'
	      },
	      solutions: {
	        header: 'Business Solutions',
	        desc: 'Billing, office, accounting, salaries, project management, customer management system (CMS).'
	      },
	      pm: {
	        header: 'Project Management',
	        desc: 'Client presentations, schedule management, quality assurance (QA).'
	      },
	      strategy: {
	        header: 'Business Strategy',
	        desc: 'Advertisement, search engine optimization (SEO), data analytics, new software solutions, growth and scaling advising.'
	      }
	    }
	  }
	};

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  about: {
	    title: 'À propos de Webjomp',
	    desc: {
	      1: 'Fondateur de Webjomp, François-Xavier Lemire obtient un diplôme en informatique avec une majeure en génie logiciel à ' + 'l\'Université McGill en 2016. Il est aussi diplômé en droit de l\'Université de Montréal depuis 2010 et membre du ' + 'Barreau du Québec depuis 2011, auparavant praticien au sein du cabinet {lla}',
	      2: 'François-Xavier a développé ses talents d\'ingénieur logiciel en touchant à plusieurs disciplines, dont la {fintech} chez ' + '{morgan}, les jeux vidéo ({skylanders}) chez {beenox}, et la publicité mobile chez {vungle}, à San Francisco.',
	      3: 'S\'il n\'est pas en train de réfléchir à sa prochaine application, il est soit en train de pratiquer la trompette, ' + 'de déguster un bon scotch ou bien de boxer!',
	      4: 'N\'hésitez pas à rester connecté!'
	    }
	  },
	  banner: {
	    header: {
	      default: 'Le web, ',
	      span: 'repensé'
	    },
	    desc: 'Création de sites web, d\'applications mobiles et {br}conseils pour solutions d\'affaires.',
	    cta: 'En savoir plus'
	  },
	  contact: {
	    title: 'Écrivez-nous',
	    form: {
	      name: 'Nom',
	      email: 'Courriel',
	      topic: 'Sujet',
	      message: 'Message',
	      receiveCopy: 'Recevoir une copie',
	      send: 'Envoyer',
	      confirm: {
	        success: 'ReCaptcha résolu? Nous vous contacterons sous peu!',
	        error: 'ERREUR: L\'envoi a échoué. Veuillez réessayer plus tard.',
	        popup: 'ERREUR: Autorisez les pop-ups pour compléter un reCaptcha.',
	        close: 'Fermer'
	      }
	    },
	    email: 'Courriel',
	    phone: 'Téléphone',
	    where: 'Lieu'
	  },
	  menu: {
	    home: 'Accueil',
	    contact: 'Contact',
	    about: {
	      title: 'À propos',
	      page: 'apropos'
	    },
	    services: {
	      title: 'Nos services',
	      page: 'services'
	    }
	  },
	  landing: {
	    tiles: {
	      moderne: {
	        title: 'Des sites Web modernes',
	        desc: 'Attrayez votre clientèle avec un look frais et captivant.'
	      },
	      agile: {
	        title: 'Agiles',
	        desc: 'Soyez impliqué dans les itérations menant à la création du site afin d\'obtenir le résultat que vous recherchez.'
	      },
	      beton: {
	        title: 'Bétons',
	        desc: 'Nous adoptons les meilleures pratiques établies par l\'industrie afin de vous fournir un site performant, sans failles, ' + 'à l\'épreuve du temps.'
	      },
	      adaptatif: {
	        title: 'Adaptatifs',
	        desc: 'Ayez un site attrayant, tant sur mobile que sur ordinateur.'
	      },
	      clair: {
	        title: 'Que vous comprendrez',
	        desc: 'Nous prenons le temps nécessaire pour répondre à toutes vos questions.'
	      },
	      abordable: {
	        title: 'À des prix réalistes',
	        desc: 'Nous minimisons les frais accessoires tels que l\'hébergement et acquisition de domaine.'
	      }
	    },
	    services: {
	      title: 'Nos services',
	      websites: 'Sites Web',
	      apps: 'Applications',
	      consulting: 'Solutions d\'affaires',
	      cta: 'En savoir plus'
	    },
	    clients: { title: 'Quelques-uns de nos clients' }
	  },
	  services: {
	    title: 'Webjomp - Services',
	    header: 'Nos services',
	    desc: 'Création de sites Web, d\'applications mobiles et conseils pour solutions d\'affaires.',
	    main: {
	      header: 'Plus que des sites Web',
	      desc: 'En plus de la création de sites Web, Webjomp offre une gamme variée de services, comme la conception d\'applications ' + 'mobiles pour Android, iOS et Windows Phones, ou encore la création de logiciels personnalisés aux besoins de votre industrie.',
	      cta: 'En savoir plus'
	    },
	    websites: {
	      header: 'Sites Web',
	      list: {
	        1: 'Commerce électronique',
	        2: 'Sites adaptatifs',
	        3: 'Blogues',
	        4: 'Référencement (SEO)',
	        5: 'Envoi massif de courriels',
	        6: 'Rédaction, révision et traduction',
	        7: 'Conceptions originales et refontes',
	        8: 'Pages statiques et dynamiques',
	        9: 'Cartes et agendas',
	        10: 'Réseaux sociaux',
	        11: 'Plateforme de messagerie',
	        12: 'Formulaires de contact',
	        13: 'Analyse de données',
	        14: 'Publicité',
	        15: 'Acquisition de domaine',
	        16: 'Hébergement Web'
	      },
	      more: {
	        content: 'Vos besoins ne se retrouvent pas dans cette liste? N\'hésitez pas à {anchor}!',
	        anchor: 'communiquer avec nous'
	      }
	    },
	    apps: {
	      header: 'Applications mobiles',
	      desc: {
	        p1: 'Nous développons pour Android, iOS et Windows Phones.',
	        p2: 'Vous avez une idée d\'application en tête? Nous vous aidons à la concrétiser à travers ces étapes: cerner les requis, ' + 'concevoir le look, développer et tester les fonctionnalités, publier l\'application.',
	        p3: 'Le travail ne s\'arrête pas là! Nous garantissons le bon fonctionnement de votre application en la maintenant à jour ' + 'et en améliorant la conception et les fonctionnalités grâce à l\'analyse de données de vos usagers.'
	      }
	    },
	    consulting: {
	      header: 'Solutions d\'affaires',
	      desc: 'Concentrez-vous sur les tâches dont vous seul êtes le professionnel.',
	      software: {
	        header: 'Développement de logiciels personnalisés',
	        desc: 'Visualisation de données, automatisation de tâches routinières.'
	      },
	      solutions: {
	        header: 'Installation de logiciels',
	        desc: 'Facturation, bureautique, comptabilité, salaires, gestion de projet, gestion de clients.'
	      },
	      pm: {
	        header: 'Gestion de projet',
	        desc: 'Présentations clients, gestion de l\'échéancier, contrôle de qualité et satisfaction.'
	      },
	      strategy: {
	        header: 'Stratégies d\'affaires',
	        desc: 'Publicité, référencement, analyse de données, adoption de technologies, conseils pour croissance rapide.'
	      }
	    }
	  }
	};

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.serviceImageFragment = undefined;
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Services = __webpack_require__(440);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesPage = function ServicesPage(_ref) {
	  var data = _ref.data;
	
	  var getImageSrc = function getImageSrc(name) {
	    return data[name].childImageSharp.responsiveResolution.src;
	  };
	
	  var images = {
	    consulting: getImageSrc('consulting'),
	    mobileapps: getImageSrc('mobileapps'),
	    websites: getImageSrc('websites')
	  };
	
	  return _react2.default.createElement(_Services2.default, { images: images });
	};
	
	ServicesPage.propTypes = {
	  data: _propTypes2.default.objectOf( // eslint-disable-line function-paren-newline
	  _propTypes2.default.shape({
	    childImageSharp: _propTypes2.default.shape({
	      responsiveResolution: _propTypes2.default.shape({
	        src: _propTypes2.default.string.isRequired
	      }).isRequired
	    }).isRequired
	  }).isRequired).isRequired // eslint-disable-line function-paren-newline
	};
	
	exports.default = ServicesPage;
	var serviceImageFragment = exports.serviceImageFragment = '** extracted graphql fragment **';
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en": 163,
		"./en.js": 163,
		"./fr": 164,
		"./fr.js": 164
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 508;


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _services = __webpack_require__(444);
	
	var _services2 = _interopRequireDefault(_services);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _services2.default;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-fr-js-e9863edec6b994ca5dc9.js